import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  @Input() type = 'default'; // default, detail, add, step-navigation, assign, delete
  @Input() title = ''; // tooltip
  @Input() shape = 'default'; // circle, round
  constructor() { }

  ngOnInit(): void {
  }

}
